/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfbpagepost3Inputs */

const en_crosspostingfbpagepost3 = /** @type {(inputs: Crosspostingfbpagepost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Post`)
};

const de_crosspostingfbpagepost3 = /** @type {(inputs: Crosspostingfbpagepost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenbeitrag`)
};

/**
* | output |
* | --- |
* | "Page Post" |
*
* @param {Crosspostingfbpagepost3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfbpagepost3 = /** @type {((inputs?: Crosspostingfbpagepost3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfbpagepost3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfbpagepost3(inputs)
	return de_crosspostingfbpagepost3(inputs)
});
export { crosspostingfbpagepost3 as "crosspostingFbPagePost" }